import { useEffect, useState } from "react";
import { useBridgeClient } from "./BridgeClientContext";
import type { LocalePayload } from "./bridge-client";

/**
 * Subscribe to host locale pushes. Returns the most recently pushed locale
 * and text direction, or `undefined` before the first push.
 */
export function useBridgeLocale(): LocalePayload | undefined {
  const client = useBridgeClient();
  const [locale, setLocale] = useState<LocalePayload | undefined>(undefined);

  useEffect(() => {
    client.onLocale((payload) => setLocale(payload));
  }, [client]);

  return locale;
}
